export const MENU = "MENU"
export const CATALOG = "CATALOG"